class AbstractKeys {
    constructor(){
        this.keys = {};
    }

    getPressKey(keyPress) {
        for (var keyName in this.keys) {
            if (this.keys[keyName] === keyPress){
               return keyName;
            }
        }
        return 'UNKNOW_KEY';
    }
    
    getCode(keyName) {
        return this.keys[keyName] 
    }
}

export default AbstractKeys;



// WEBPACK FOOTER //
// ./src/devices/all/AbstractKeys.js